import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import "../Pages/CreateEditPage.css";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import "./ModalForm.css";
import { Referenti } from "../lib/interface";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/Store";
import { allPost, allPut } from "../Redux/Actions.tsx";
import { urlreferenti } from "../lib/api.ts";
import DeleteModal from "./DeleteModal.tsx";
import { useAlert } from "./Alert.tsx";
import { FaTrashAlt } from "react-icons/fa";

interface ModalFormReferentiProps {
  arrayReferenti: Referenti[];
  onAddReferente: (nuovoReferente: Referenti) => void;
  updateReferenti: (updateReferente: Referenti) => void;
  setArrayReferenti: (arrayReferenti: Referenti[]) => void;
  action: string; // "crea" | "modifica"
  idCommittente?: string; // se in modifica, l'ID del committente
}

const ModalFormReferenti: React.FC<ModalFormReferentiProps> = ({
  arrayReferenti,
  onAddReferente,
  updateReferenti,
  setArrayReferenti,
  action,
  idCommittente,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [isDelete, setIsDelete] = useState("");
  const [referente, setReferente] = useState<Referenti>({
    id: "",
    nome: "",
    cognome: "",
    telefono: "",
    email: "",
    ruolo: "",
    committenteId: "",
  });

  // Nuovo stato "errors": se è vuoto => "", se c'è errore => testo
  const [errors, setErrors] = useState({
    nome: "",
  });

  const [index, setIndex] = useState(-1);
  const [deleteReferente, setDeleteReferente] = useState<Referenti | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const dispatch: AppDispatch = useDispatch();
  const { token } = useSelector((state: RootState) => state.login);
  const showAlert = useAlert();

  // Apertura modale in "creazione"
  const handleOpenModal = () => {
    setIsCreate(true);
    setIndex(-1);
    setReferente({
      id: "",
      nome: "",
      cognome: "",
      telefono: "",
      email: "",
      ruolo: "",
      committenteId: "",
    });
    setErrors({
      nome: "",
    });
    setModalOpen(true);
  };

  // Apertura modale in "modifica"
  const showReferente = (refSelezionato: Referenti, idx: number) => {
    setIndex(idx);
    setIsCreate(false);
    setReferente(refSelezionato);
    setErrors({
      nome: "",
    });
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setReferente({
      id: "",
      nome: "",
      cognome: "",
      telefono: "",
      email: "",
      ruolo: "",
      committenteId: "",
    });
    setErrors({
      nome: "",
    });
  };

  // OnChange generico
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setReferente((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "", // reset errore al cambio
    }));
  };

  // Gestione "icona X" => elimina
  const handleModificaReferente = (id: string) => {
    if (id) {
      setIsDelete(id);
    }
  };

  const deleteReferenti = (refToDelete: Referenti) => {
    if (isDelete) {
      handleOpenDeleteModal(refToDelete);
    } else {
      setArrayReferenti(arrayReferenti.filter((r) => r.id !== isDelete));
    }
    handleCloseModal();
  };

  const handleOpenDeleteModal = (ref: Referenti) => {
    setDeleteReferente(ref);
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteReferente(null);
    setIsDeleteModalOpen(false);
  };

  // Validazione campi
  const validateFields = () => {
    let newErrors = {
      nome: "",
    };
    let isValid = true;

    // nome
    if (!referente.nome.trim()) {
      newErrors.nome = "Campo obbligatorio.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Salvataggio
  const handleSubmit = async () => {
    // Validazione
    if (!validateFields()) {
      showAlert("danger", "Errore", "Compila correttamente tutti i campi obbligatori.", "bottom-end", 3000);
      return;
    }

    // Se "committenteId" dal genitore
    const referentePreFetch: Referenti = {
      ...referente,
      committenteId: idCommittente || "",
    };

    // Creazione
    if (!referente.id) {
      if (action === "modifica" && idCommittente) {
        // DB
        dispatch(allPost(urlreferenti, token, referentePreFetch, showAlert))
          .then((idReferente) => {
            if (idReferente) {
              showAlert("success", "Creato", "Referente creato con successo.", "bottom-end", 3000);
              const nuovoRef = {
                ...referentePreFetch,
                id: idReferente,
              };
              onAddReferente(nuovoRef);
            } else {
              console.error("Creazione referente fallita");
            }
          })
          .catch(console.error);
      } else {
        // locale
        const nuovoArray = [...arrayReferenti];
        if (index >= 0) {
          nuovoArray[index] = referentePreFetch;
        } else {
          nuovoArray.push(referentePreFetch);
        }
        setArrayReferenti(nuovoArray);
      }
    } else {
      // Modifica
      dispatch(allPut(`${urlreferenti}/${referente.id}`, token, referentePreFetch, showAlert)).then(
        (updatedreferente) => {
          if (updatedreferente) {
            showAlert("success", "Salvato", "Referente modificato con successo.", "bottom-end", 3000);
            updateReferenti(updatedreferente);
          } else {
            console.error("Modifica del referente fallita");
          }
        }
      );
    }

    handleCloseModal();
  };

  return (
    <>
      <Container className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="text-start m-0">Referenti</h5>
          <Button onClick={handleOpenModal} variant="primary" className="ms-2 button">
            <img
              src="../../assets/add.svg"
              alt="Aggiungi preferente"
              className="button-icon"
              style={{ marginRight: "8px" }}
            />
            Aggiungi un nuovo referente
          </Button>
        </div>

        <div className="referenti-list ">
          {arrayReferenti.map((ref, idx) => (
            <div
              key={ref.id || idx}
              className="referente-item"
              style={{ cursor: "pointer" }}
              onClick={() => showReferente(ref, idx)}
            >
              <h6>
                <b>{`${ref.nome} ${ref.cognome}`}</b>
              </h6>
              <Row className="d-flex justify-content-between mb-3">
                <Col xs={5} className="referente-info">
                  <img src="../../assets/IconMail.svg" alt="Mail Icon" className="svg-icon" />
                  <span>{ref.email}</span>
                </Col>
                <Col xs={3} className="referente-info">
                  <img src="../../assets/IconPhone.svg" alt="Phone Icon" className="svg-icon" />
                  <span>{ref.telefono}</span>
                </Col>
                <Col xs={3} className="referente-info">
                  <img src="../../assets/IconRuolo.svg" alt="Role Icon" className="svg-icon" />
                  <span>{ref.ruolo}</span>
                </Col>
                <Col xs={1}>
                  <i
                    className="pi pi-times me-2"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleModificaReferente(ref.id || "");
                    }}
                  ></i>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </Container>

      <Dialog
        visible={isModalOpen}
        header={
          <>
            <h6>
              <b>{isCreate ? "Crea Nuovo Referente" : "Modifica Referente"}</b>
            </h6>
            <hr />
          </>
        }
        style={{ width: "40vw", minHeight: "50vh", borderRadius: "24px" }}
        className="custom-dialog mb-5"
        onHide={handleCloseModal}
      >
        <div className="modal-content mt-3" style={{ borderRadius: "24px" }}>
          <Row className="px-4">
            {/* Nome (obbligatorio) */}
            <Col xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Nome <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <InputText
                  name="nome"
                  value={referente.nome}
                  onChange={handleChange}
                  placeholder="Nome"
                  style={errors.nome ? { width: "100%", border: "1px solid red" } : { width: "100%" }}
                />
                {errors.nome && <p style={{ color: "red" }}>{errors.nome}</p>}
              </Form.Group>
            </Col>

            {/* Cognome (obbligatorio) */}
            <Col xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Cognome <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <InputText
                  name="cognome"
                  value={referente.cognome}
                  onChange={handleChange}
                  placeholder="Cognome"
                  style={{ width: "100%" }}
                />
              </Form.Group>
            </Col>

            <hr />

            {/* Email (obbligatorio) */}
            <Col xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Email <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <InputText
                  name="email"
                  value={referente.email}
                  onChange={handleChange}
                  placeholder="Email"
                  style={{ width: "100%" }}
                />
              </Form.Group>
            </Col>

            {/* Ruolo (obbligatorio) */}
            <Col xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Ruolo <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <InputText
                  name="ruolo"
                  value={referente.ruolo}
                  onChange={handleChange}
                  placeholder="Ruolo"
                  style={{ width: "100%" }}
                />
              </Form.Group>
            </Col>

            {/* Telefono (obbligatorio) */}
            <Col xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Telefono <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <InputText
                  name="telefono"
                  value={referente.telefono}
                  onChange={handleChange}
                  placeholder="Telefono"
                  style={{ width: "100%" }}
                />
              </Form.Group>
            </Col>

            <hr className="mb-3" />
          </Row>
        </div>

        <div className="d-flex justify-content-between align-items-center px-4 pb-3">
          {!isCreate && (
            <div className="d-flex align-items-center">
              <FaTrashAlt className="icon-action" title="Elimina" style={{ cursor: "pointer", color: "red" }} />
              <p
                className="scritta-elimina ms-2"
                style={{ cursor: "pointer", color: "red" }}
                onClick={() => deleteReferenti(referente)}
              >
                Elimina
              </p>
            </div>
          )}

          <Button className="button d-flex px-3 ms-auto" onClick={handleSubmit}>
            <i className="pi pi-save me-2"></i>
            <p className="p-0 m-0">Salva</p>
          </Button>
        </div>
      </Dialog>

      {/* DeleteModal per Referente */}
      {deleteReferente && (
        <DeleteModal
          type="referente"
          idObj={deleteReferente.id}
          matchIdentifier={`${deleteReferente.nome} ${deleteReferente.cognome}`}
          show={isDeleteModalOpen}
          onClose={handleCloseDeleteModal}
          onDeleteSuccess={() => {
            // Rimuove il referente dall'array
            setArrayReferenti(arrayReferenti.filter((r) => r.id !== deleteReferente.id));
            handleCloseModal();
          }}
        />
      )}
    </>
  );
};

export default ModalFormReferenti;
